<template>
  <div>
    <div class="card p-3">
      <h2 class="fs-6">RIWAYAT UPLOAD</h2>
      <div class="d-flex justify-content-end mb-2">
        <div class="list-group list-group-horizontal">
          <button type="button" class="list-group-item list-group-item-action py-1 px-3 text-xs custom-button" :class="{ 'custom-active': showMode === 'active', 'custom-inactive': showMode !== 'active' }" @click="changeMode('active')">
            Active
          </button>
          <button type="button" class="list-group-item list-group-item-action py-1 px-3 text-xs custom-button" :class="{ 'custom-active': showMode === 'deleted', 'custom-inactive': showMode !== 'deleted' }" @click="changeMode('deleted')">
            Deleted
          </button>
          <button type="button" class="list-group-item list-group-item-action py-1 px-3 text-xs custom-button" :class="{ 'custom-active': showMode === 'all', 'custom-inactive': showMode !== 'all' }" @click="changeMode('all')">All</button>
        </div>
      </div>

      <div class="table-responsive">
        <table class="table">
          <thead>
            <tr>
              <th class="text-center text-secondary text-xxs font-weight-bolder opacity-7">NO</th>
              <th class="text-center text-secondary text-xxs font-weight-bolder opacity-7">TANGGAL</th>
              <th class="text-center text-secondary text-xxs font-weight-bolder opacity-7">BATCH</th>
              <th class="text-center text-secondary text-xxs font-weight-bolder opacity-7">KLIEN</th>
              <th class="text-center text-secondary text-xxs font-weight-bolder opacity-7">TOTAL DATA</th>
              <th class="text-center text-secondary text-xxs font-weight-bolder opacity-7">BERHASIL</th>
              <th class="text-center text-secondary text-xxs font-weight-bolder opacity-7">DUPLIKASI</th>
              <th class="text-center text-secondary text-xxs font-weight-bolder opacity-7"></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(data, index) in dataAktif" :key="'aktif-' + index">
              <td class="text-center align-middle text-sm">
                <small>{{ props.currentPage > 0 ? index + 1 + props.currentPage * 10 : index + 1 }}</small>
              </td>
              <td class="text-center align-middle text-sm">
                <small>{{ `${nol(data.importTgl[2])}-${nol(data.importTgl[1])}-${nol(data.importTgl[0])}` }}</small>
              </td>
              <td class="text-center align-middle text-sm">
                <small>{{ data.batch }}</small>
              </td>
              <td class="text-center align-middle text-sm">
                <small>{{ data.importClientName }}</small>
              </td>
              <td class="text-center align-middle text-sm">
                <small>{{ data.importTotal }}</small>
              </td>
              <td class="text-center align-middle text-sm">
                <small>{{ data.importAccept }}</small>
              </td>
              <td class="text-center align-middle text-sm">
                <small>{{ data.inDuplicate }}</small>
              </td>
              <td class="text-center align-middle text-balance">
                <div v-if="(data.deletedAt && data.deletedBy) || data.deleted === true" class="d-flex justify-content-center">
                  <div class="text-wrap" style="min-width: 120px; max-width: 200px">
                    <DeletedInfo :item="data" />
                  </div>
                </div>
                <div v-else class="btn-group justify-content-center" role="group" style="max-width: 200px">
                  <button type="button" class="btn btn-success btn-sm px-2 py-1 d-flex justify-content-center align-items-center" @click="lihatBatch(data.batch)" style="width: 30px; height: 30px">
                    <i class="fa fa-paper-plane text-white"></i>
                  </button>
                  <button type="button" class="btn btn-success btn-sm px-2 py-1 d-flex justify-content-center align-items-center" style="width: 30px; height: 30px" title="Hapus batch" @click="addSelectedBatch(data.batch)">
                    <i class="fa fa-trash text-white"></i>
                  </button>
                  <button
                    type="button"
                    class="btn btn-success btn-sm px-2 py-1 d-flex justify-content-center align-items-center"
                    style="width: 30px; height: 30px"
                    title="Gudangkan batch"
                    @click="gudangkanBatch(data.batch, data.statusBatch)"
                  >
                    <i class="fa fa-check-circle text-white"></i>
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="row mt-3">
        <div class="col-6">
          <h6>Showing {{ pageStart }} to {{ pageEnd }} from {{ filteredDataLength }} entries</h6>
        </div>
        <div class="col-6">
          <div class="float-end">
            <slot name="button"></slot>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, ref, watch, onMounted } from "@vue/runtime-core";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import { ApiService } from "@/axios/apiService";
import DeletedInfo from "@/components/DeletedInfo.vue";

const apiService = new ApiService();
const router = useRouter();
const store = useStore();
const showMode = ref("active"); // default tetap active

const props = defineProps({
  dataTable: Array,
  dataLength: Number,
  pageLength: Number,
  offset: Number,
  size: Number,
  currentPage: Number,
});
const emits = defineEmits(["afterdone", "changeShowMode"]);

const sortDataByTime = (dataArray) => {
  return dataArray.sort((a, b) => {
    if (!a.deletedAt && !b.deletedAt) {
      const dateA = new Date(a.importTgl[0], a.importTgl[1] - 1, a.importTgl[2]);
      const dateB = new Date(b.importTgl[0], b.importTgl[1] - 1, b.importTgl[2]);
      return dateB - dateA;
    }

    if (a.deletedAt && b.deletedAt) {
      const deleteDateA = new Date(a.deletedAt);
      const deleteDateB = new Date(b.deletedAt);
      return deleteDateB - deleteDateA;
    }

    if (!a.deletedAt && b.deletedAt) return -1;
    if (a.deletedAt && !b.deletedAt) return 1;

    return 0;
  });
};

const changeMode = (mode) => {
  showMode.value = mode;
  emits("changeShowMode", mode);
};

const dataAktif = computed(() => {
  if (!Array.isArray(props.dataTable)) {
    return [];
  }
  return sortDataByTime([...props.dataTable]);
});

const pageSize = computed(() => props.size || 10);
const pageStart = computed(() => {
  if (props.dataLength === 0) return 0;
  return props.currentPage * pageSize.value + 1;
});
const pageEnd = computed(() => {
  if (props.dataLength === 0) return 0;
  const end = (props.currentPage + 1) * pageSize.value;
  return end > props.dataLength ? props.dataLength : end;
});

const lihatBatch = (batch) => {
  store.state.selectedBatchUpload = batch;
  router.push({ name: "Internal" });
};

const addSelectedBatch = (batch) => {
  let payload = {
    text: `Batch ${batch} akan dihapus beserta data Perangkat dan data Riwayat`,
    text1: `Batch ${batch} beserta data perangkat dan data riwayat berhasil dihapus`,
    funs: "",
  };
  payload.funs = async () => {
    try {
      await apiService.deleteRiwayatUpload(batch);
      emits("afterdone");
    } catch (error) {
      if (error.code === "ERR_BAD_REQUEST") {
        store.dispatch("swalError", {
          code: error.response.data.status,
          text: error.response.data.message,
        });
      }
      console.log(error);
      return;
    }
  };
  store.dispatch("swalConfirm", payload);
};

const gudangkanBatch = (batch, status) => {
  store.state.isLoading = true;
  if (status === 9) {
    let payload = {
      code: "Internal",
      text: "batch sudah digudangkan",
    };
    store.dispatch("swalError", payload);
  } else {
    let payload = {
      text: `Batch ${batch} akan digudangkan `,
      text1: `Batch ${batch} berhasil digudangkan`,
      funs: "",
    };
    payload.funs = async () => {
      try {
        await apiService.gudangkanBatch(batch);
        emits("afterdone");
        store.dispatch("swalSuccess", {
          text: "berhasil menggudangkan batch " + batch,
        });
        store.state.isLoading = false;
      } catch (error) {
        console.log(error);
        store.state.isLoading = false;
      }
    };
    store.dispatch("swalConfirm", payload);
  }
};

const nol = (x) => {
  const y = x > 9 ? (x > 99 ? x : "" + x) : "0" + x;
  return y;
};
</script>
